/**
 * Created by kz on 28.06.17.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import tender from './modules/tender'
import participation from './modules/participation'
import mailing from './modules/mailing'
import companies from './modules/companies'
import {postBase, getBase} from '@api/questionsBase'

import _ from 'lodash'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loading: false,
    success: {
      message: null,
      enabled: false
    },
    error: {
      message: null,
      enabled: false
    },
    questionsBase: {
      groups: [{
        name: 'Общие вопросы',
        weight: 3,
        questions: [
          {
            text: 'Как дела?',
            weight: 2,
            type: 'one_option',
            options: [
              {
                value: 'Норм',
                weight: 3
              },
              {
                value: 'Пойдет',
                weight: 4
              },
              {
                value: 'Супер',
                weight: 5
              }
            ]
          }]
      }]
    }
  },
  mutations: {
    startLoading (state) {
      state.loading = true
    },
    stopLoading (state) {
      state.loading = false
    },
    loading (state, loadingState) {
      state.loading = loadingState
    },
    clearSuccessMessage (state) {
      state.success.message = null
      state.success.enabled = false
    },
    successMessage (state, payload) {
      state.success.message = payload
      state.success.enabled = true
    },
    clearErrorMessage (state) {
      state.error.message = null
      state.error.enabled = null
    },
    errorMessage (state, payload) {
      state.error.message = payload
      state.error.enabled = true
    },
    patchGroup (state, {index, group: {name, weight}}) {
      state.questionsBase.groups[index].name = name
      state.questionsBase.groups[index].weight = weight
    },
    patchQuestion (state, {question, group, currentGroupIndex, currentQuestionIndex}) {
      if (state.questionsBase.groups[currentGroupIndex].questions[currentQuestionIndex]) {
        if (group === currentGroupIndex) {
          _.assignIn(state.questionsBase.groups[currentGroupIndex].questions[currentQuestionIndex], question)
        } else {
          state.questionsBase.groups[currentGroupIndex].questions.splice(currentQuestionIndex, 1)
          state.questionsBase.groups[group].questions.push(question)
        }
      }
    },
    postQuestion (state, {question, group}) {
      if (state.questionsBase.groups[group]) {
        state.questionsBase.groups[group].questions.push(question)
      }
    },
    addGroup (state) {
      state.questionsBase.groups.push({
        name: 'Новая группа',
        weight: 1,
        questions: []
      })
    },
    deleteQuestion (state, {groupNumber: g, questionNumber: q}) {
      state.questionsBase.groups[g].questions.splice(q, 1)
    },
    deleteGroup (state, index) {
      state.questionsBase.groups.splice(index, 1)
    },
    deleteGroupSaving (state, index) {
      if (state.questionsBase.groups[index]) {
        state.questionsBase.groups[index].questions.forEach((q) => {
          state.questionsBase.groups[0].questions.push(_.cloneDeep(q))
        })
      }
      state.questionsBase.groups.splice(index, 1)
    },
    copyGroup (state, index) {
      if (state.questionsBase.groups[index]) {
        state.questionsBase.groups.push(_.cloneDeep(state.questionsBase.groups[index]))
      }
    },
    copyQuestion (state, {groupNumber: g, questionNumber: q}) {
      if (state.questionsBase.groups[g] && state.questionsBase.groups[g].questions[q]) {
        state.questionsBase.groups[g].questions.push(_.cloneDeep(state.questionsBase.groups[g].questions[q]))
      }
    },
    loadBase (state, {groups}) {
      if (groups) {
        state.questionsBase.groups = groups
      }
    }
  },
  getters: {
    loading: state => state.loading,
    success: state => state.success,
    error: state => state.error,
    questionsBase: state => state.questionsBase
  },
  modules: {
    auth,
    tender,
    participation,
    mailing,
    companies
  },
  actions: {
    postBase ({state, commit}) {
      postBase({
        groups: state.questionsBase.groups
      }).then(() => {
        commit('successMessage', 'База сохранена', {root: true})
      }).catch((err) => {
        commit('errorMessage', err.message, {root: true})
      })
    },
    getBase ({commit}) {
      commit('startLoading')
      getBase().then(({data: {groups}}) => {
        commit('loadBase', {groups}, {root: true})
        commit('stopLoading')
      }).catch((err) => {
        if (!(err.response.status === 404)) {
          commit('errorMessage', err.message, {root: true})
        }
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js